import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { applyMiddleware, createStore, Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createRootReducer from './rootReducer';
import rootSaga from './rootSaga';

const middlewares: Middleware[] = [];

export const history = createBrowserHistory();

const configureStore = () => {
  const rootReducer = createRootReducer(history);
  const sagaMiddleware = createSagaMiddleware();
  const routerMiddleware = createRouterMiddleware(history);

  middlewares.push(sagaMiddleware);
  middlewares.push(routerMiddleware);

  const store = createStore(
    rootReducer,
    applyMiddleware(...middlewares)
  );
  sagaMiddleware.run(rootSaga);

  return store;
};  

export default configureStore;